import { AuthService } from '@/core/auth/auth.service';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@env/environment';
import { catchError, from, of, switchMap } from 'rxjs';

function noDomainUrl(url: string): boolean {
    return url.startsWith('/');
}

export const httpAuthInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    let url = req.url;
    const basePath = environment.apis.apiSicom;
    const needsAuth = (url: typeof req.url) => url.includes(environment.apis.apiSicom);

    if (noDomainUrl(url)) {
        url = `${basePath}${url}`;

        let params = req.params;
        params.keys().forEach((key) => {
            if (params.get(key) === 'undefined') {
                params = params.delete(key);
            }
        });

        req = req.clone({ url, params });
    }

    if (needsAuth(url)) {
        // Importante: não capturar erros da requisição HTTP (next(authReq)), para não mascarar
        // problemas de rede/CORS e evitar reexecução sem Authorization.

        return from(authService.waitForToken()).pipe(
            catchError((err) => {
                console.error('Erro ao obter token:', err);
                return of(null as unknown as string);
            }),
            switchMap((token) => {
                const reqToSend = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;
                return next(reqToSend);
            })
        );
    }

    return next(req);
};
